// extracted by mini-css-extract-plugin
export default {"v-application":"Radio_v-application_jhTF2","text-h1":"Radio_text-h1_l36Ep","text-h2":"Radio_text-h2_HuPy0","radio":"Radio_radio_p11__"};